import SpriteSymbol from "../../../../../node_modules/.pnpm/svg-baker-runtime@1.4.7/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/.pnpm/svg-sprite-loader@6.0.11/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-800",
  "use": "icon-800-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"currentColor\" class=\"qi-800\" viewBox=\"0 0 16 16\" id=\"icon-800\">\n  <circle cx=\"8\" cy=\"8\" r=\"8\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol